import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/share';

import { Campaign } from '../../models/campaign.model';
import { PagedMeasures } from '../../models/paged-measures.interface';
import { Api } from '../util/api';

@Injectable()
export class CampaignsService {
  private endpoint: string = 'campaigns';

  constructor(private api: Api) {
  }

  public closeCampaign(campaignId: number) {
    const campaign = new Campaign();
    campaign.id = campaignId;
    campaign.state = 'CLOSED';
    return this.api.put(`${this.endpoint}/${campaignId}`, campaign).map(
      (campaign: Campaign) => this.api.handleSuccess(campaign, 'Campagne clôturée avec succès !')
    );
  }

  public downloadMeasureLeft(campaignId: string) {
    const options = {
      responseType: 'text'
    };
    return this.api.get(`${this.endpoint}/${campaignId}/measuresLeft/download`, undefined, options).map(
      csvText => new Blob([csvText], { type: 'text/csv;charset=windows-1252' }));
  }

  public getCampaign(lineId: number): Observable<Campaign> {
    return this.api.get(`${this.endpoint}/active/${lineId}`).map(
      campaigns => campaigns[0]
    );
  }

  public getCampaigns(): Observable<Campaign[]> {
    return this.api.get(`${this.endpoint}`);
  }

  public getCampaignsClosed(lineId: number): Observable<Campaign[]> {
    return this.api.get(`${this.endpoint}/closed/${lineId}`);
  }

  public getMeasuresLeft(campaignId: number, page: number = 0, size: number = 15): Observable<PagedMeasures> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());
    return this.api.get(`${this.endpoint}/${campaignId}/measuresLeft`, params);
  }

  public openNewCampaign(lineId: number) {
    let campaign = new Campaign();
    campaign.line.id = lineId;
    return this.api.put(`${this.endpoint}`, campaign).map(
      (campaign: Campaign) => this.api.handleSuccess(campaign, 'Campagne démarrée avec succès !')
    );
  }

  public reopenCampaign(campaignId: number) {
    const campaign = new Campaign();
    campaign.id = campaignId;
    campaign.state = 'IN_PROGRESS';
    return this.api.put(`${this.endpoint}/${campaignId}`, campaign).map(
      (campaign: Campaign) => this.api.handleSuccess(campaign, 'Campagne relancée avec succès !')
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/campaigns.service.ts